import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GoalPermissionsHelper } from 'src/app/helpers/goal-permissions.helper';
import { IResult, IResultModel, ResultModel } from 'src/app/models/general/result.model';
import { GoalPeriod } from 'src/app/models/goalperiod.model';
import { GroupGoal } from 'src/app/models/group-goal.model';
import { State } from 'src/app/models/state.model';
import { GoalService, StateService } from 'src/app/services';
import { ErrorMessageService } from 'src/app/shared/services';

@Component({
  selector: 'app-group-goal-view',
  templateUrl: './group-goal-view.component.html',
  styleUrl: './group-goal-view.component.scss'
})
export class GroupGoalViewComponent {
  
  @Input()
  public groupGoal: GroupGoal;

  @Input()
  public goalPeriod: GoalPeriod;

  @Output()
  public delete = new EventEmitter<number>();

  public state: State;
  
  constructor(private goalService: GoalService, stateService: StateService, private msgService: ErrorMessageService) {
    this.state = stateService.state;
  }

  allowDelete(): boolean {
   return GoalPermissionsHelper.canGroupGoalDelete(this.goalPeriod, this.state);
  }

  onDelete() {
    this.goalService.deleteGroupGoal(this.groupGoal.id).subscribe({ next: () => {
      this.delete.emit(this.groupGoal.id);
      this.msgService.showSnackBarMessage('deleteSuccessful');
    }, error: (err: IResultModel<ResultModel>) => {
        this.msgService.handleError<ResultModel>(err);
    }});
  }
}
